/* eslint-disable @typescript-eslint/no-explicit-any */
export class DialogConfig<D = any> {
  data?: D;
}